import globalStore from "@/store";

const login = {
  namespaced: true,
  state: {
    showLoader: false,
  },
  actions: {},
  mutations: {
    SHOW_LOADER: function(state) {
      state.showLoader = true;
    },
    HIDE_LOADER: function(state) {
      state.showLoader = false;
    },
  },
};
export default login;
